import React from 'react'

import { useQuery } from '@tanstack/react-query'
import { CMSGlobalContent } from '@mindfulchefuk/features/CMS/interfaces'
import { CMSModalBanner } from '@mindfulchefuk/features/CMS/components/CMSModalBanner'
import { trackAnalyticsEvent } from '@mindfulchefuk/utils/analytics/amplitude/amplitudeAdapter'
import { ProductType } from '@mindfulchefuk/analytics'
import { getCMSGlobalContent } from '@mindfulchefuk/features/CMS/services/getCMSGlobalContent'

export const RecipeModalBanner = ({ recipeId }: { recipeId: string }) => {
  const { data }: { data: CMSGlobalContent } = useQuery({
    queryKey: ['cms-global-content'],
    queryFn: getCMSGlobalContent,
  })

  const banner = data?.recipeModalBanners.find((modalBanner) =>
    modalBanner.recipes.includes(recipeId)
  )

  if (!banner) return null

  return (
    <CMSModalBanner
      testId="cms-recipe-partnership-banner"
      redirectURL={banner.url}
      clickHandler={() =>
        trackAnalyticsEvent({
          name: 'product details banner clicked',
          data: {
            'product category': ProductType.RECIPES,
            'product type': 'recipe',
            'banner name': banner.analyticsRef,
          },
        })
      }
      margin={{ mb: 16 }}
      responsiveImage={banner.image}
      altText={banner.image.alternativeText}
      imgTestId="cms-recipe-partnership-banner-image"
    />
  )
}
